import { render } from "./TranscriptId.vue?vue&type=template&id=b8522e7e&scoped=true&ts=true"
import script from "./TranscriptId.vue?vue&type=script&lang=ts"
export * from "./TranscriptId.vue?vue&type=script&lang=ts"

import "./TranscriptId.vue?vue&type=style&index=0&id=b8522e7e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8522e7e"]])

export default __exports__